import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../assets/styles/Project.scss';
import { usePageTitle } from '../hooks/usePageTitle';
import terraformarticle from '../assets/images/terraformarticle.png';
import argocdimage from '../assets/images/ARGOCDIMAGES.png';

const projectMeta = [
  { imageSrc: terraformarticle, articlePath: '/terraform-article' },
  { imageSrc: argocdimage,      articlePath: '/argocd-article' },
];

type ProjectTranslation = { title: string; description: string };

function Project() {
  const { t } = useTranslation();
  usePageTitle('Projets');
  const projects = t('projects', { returnObjects: true }) as ProjectTranslation[];

  return (
    <section className="projects-section">
      <div className="projects-header">
        <h1>{t('projectsTitle')}</h1>
        <div className="projects-rule" />
        <p className="projects-intro">{t('projectsIntro')}</p>
      </div>
      <div className="projects-grid">
        {projects.map((project, index) => {
          const meta = projectMeta[index];
          const inner = (
            <div className="project-card">
              <div className="project-image-wrap">
                <img src={meta.imageSrc} alt={project.title} />
              </div>
              <div className="project-body">
                <span className="project-tag">{t('projectTag')}</span>
                <h2 className="project-title">{project.title}</h2>
                <p className="project-desc">{project.description}</p>
                <div className="project-footer">
                  {meta.articlePath ? (
                    <span className="project-read-more">{t('readArticle')}</span>
                  ) : (
                    <span className="project-badge">{t('comingSoon')}</span>
                  )}
                </div>
              </div>
            </div>
          );

          return meta.articlePath ? (
            <Link key={index} to={meta.articlePath} className="project-link">{inner}</Link>
          ) : (
            <div key={index} className="project-link project-link--disabled">{inner}</div>
          );
        })}
      </div>
    </section>
  );
}

export default Project;
